<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import FileUpload from '../../Shared/FileUpload.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="form__header">
            {{ t('lan_vedflutning_step5_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <!-- Check1 -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.check1"
            :readonly="props.disable"
            :label="t('lan_vedflutning_step5_check1')"
          />
          <transition name="list">
            <div v-if="umsokn.check1">
              <FileUpload
                :umsoknType="16"
                :umsoknId="umsokn.id"
                :filespace="1"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Check2 -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.check2"
            :readonly="props.disable"
            :label="t('lan_vedflutning_step5_check2')"
          />
          <transition name="list">
            <div v-if="umsokn.check2">
              <FileUpload
                :umsoknType="16"
                :umsoknId="umsokn.id"
                :filespace="2"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Check3 -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.check3"
            :readonly="props.disable"
            :label="t('lan_vedflutning_step5_check3')"
          />
          <transition name="list">
            <div v-if="umsokn.check3">
              <FileUpload
                :umsoknType="16"
                :umsoknId="umsokn.id"
                :filespace="3"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Check4 -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.check4"
            :readonly="props.disable"
            :label="t('lan_vedflutning_step5_check4')"
          />
          <transition name="list">
            <div v-if="umsokn.check4">
              <FileUpload
                :umsoknType="16"
                :umsoknId="umsokn.id"
                :filespace="4"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p style="font-weight:bold">
            {{ t('lan_vedflutning_step5_athugasemd') }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
